/**
 * @generated SignedSource<<668b4d022e2793ac2dbc7b3e4985a3dd>>
 * @relayHash 55f3d892973ea7ed4cc688e6441d9c59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 784261a4d425109d278a3a61a6672faf0cfea7f14a8a1d3b4fa6f4a70e01f76e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraIssueSearchFieldSetSelectedState = "ALL" | "NON_SELECTED" | "SELECTED" | "%future added value";
export type JiraIssueSearchFieldSetsFilter = {
  fieldSetSelectedState?: JiraIssueSearchFieldSetSelectedState | null | undefined;
  searchString?: string | null | undefined;
};
export type fetchColumnPickerOptionsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  filter?: JiraIssueSearchFieldSetsFilter | null | undefined;
  first?: number | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  shouldSkipOldQuery: boolean;
  shouldUseIFCOldQuery: boolean;
  shouldUseNewQuery: boolean;
  viewId?: string | null | undefined;
};
export type fetchColumnPickerOptionsQuery$data = {
  readonly jira: {
    readonly issueSearchViewByNamespaceAndViewId?: {
      readonly fieldSets: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly displayName: string;
            readonly fieldSetId: string;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly type: string;
          };
        } | null | undefined>;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number;
      };
    };
    readonly issueSearchViewResult?: {
      readonly fieldSets?: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly displayName: string;
            readonly fieldSetId: string;
            readonly fieldSetPreferences: {
              readonly width: number | null | undefined;
            } | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly type: string;
          };
        } | null | undefined>;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number;
      };
    };
    readonly jiraIssueSearchView?: {
      readonly fieldSets?: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly displayName: string;
            readonly fieldSetId: string;
            readonly fieldSetPreferences: {
              readonly width: number | null | undefined;
            } | null | undefined;
            readonly fieldType: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly type: string;
          };
        } | null | undefined>;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number;
      } | null | undefined;
    };
  };
};
export type fetchColumnPickerOptionsQuery = {
  response: fetchColumnPickerOptionsQuery$data;
  variables: fetchColumnPickerOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkipOldQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldUseIFCOldQuery"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldUseNewQuery"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v10 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v11 = {
  "kind": "Variable",
  "name": "namespace",
  "variableName": "namespace"
},
v12 = {
  "kind": "Variable",
  "name": "viewId",
  "variableName": "viewId"
},
v13 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v16 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v18 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v19 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v20 = {
  "kind": "ScalarField",
  "name": "type"
},
v21 = {
  "concreteType": "JiraFieldType",
  "kind": "LinkedField",
  "name": "fieldType",
  "plural": false,
  "selections": [
    (v19/*: any*/)
  ]
},
v22 = {
  "concreteType": "JiraFieldSetPreferences",
  "kind": "LinkedField",
  "name": "fieldSetPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "width"
    }
  ]
},
v23 = [
  (v10/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "jql",
        "variableName": "jql"
      }
    ],
    "kind": "ObjectValue",
    "name": "issueSearchInput"
  },
  (v11/*: any*/),
  (v12/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "id"
},
v25 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v26 = [
  {
    "args": (v14/*: any*/),
    "concreteType": "JiraIssueSearchFieldSetConnection",
    "kind": "LinkedField",
    "name": "fieldSets",
    "plural": false,
    "selections": [
      (v15/*: any*/),
      (v16/*: any*/),
      {
        "concreteType": "JiraIssueSearchFieldSetEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          (v17/*: any*/),
          {
            "concreteType": "JiraIssueSearchFieldSet",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "fetchColumnPickerOptionsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "condition": "shouldSkipOldQuery",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v13/*: any*/),
                    "concreteType": "JiraIssueSearchView",
                    "kind": "LinkedField",
                    "name": "issueSearchViewByNamespaceAndViewId",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "args": (v14/*: any*/),
                          "concreteType": "JiraIssueSearchFieldSetConnection",
                          "kind": "LinkedField",
                          "name": "fieldSets",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v15/*: any*/),
                              "action": "THROW",
                              "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount"
                            },
                            (v16/*: any*/),
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "RequiredField",
                                    "field": {
                                      "concreteType": "JiraIssueSearchFieldSet",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "RequiredField",
                                          "field": (v18/*: any*/),
                                          "action": "THROW",
                                          "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.fieldSetId"
                                        },
                                        {
                                          "kind": "RequiredField",
                                          "field": (v19/*: any*/),
                                          "action": "THROW",
                                          "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.displayName"
                                        },
                                        {
                                          "kind": "RequiredField",
                                          "field": (v20/*: any*/),
                                          "action": "THROW",
                                          "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.type"
                                        },
                                        (v21/*: any*/)
                                      ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.issueSearchViewByNamespaceAndViewId"
                }
              ]
            },
            {
              "condition": "shouldUseNewQuery",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "condition": "shouldUseIFCOldQuery",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "args": (v13/*: any*/),
                        "kind": "LinkedField",
                        "name": "issueSearchViewResult",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "args": (v14/*: any*/),
                                  "concreteType": "JiraIssueSearchFieldSetConnection",
                                  "kind": "LinkedField",
                                  "name": "fieldSets",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v15/*: any*/),
                                      "action": "THROW",
                                      "path": "jira.issueSearchViewResult.fieldSets.totalCount"
                                    },
                                    (v16/*: any*/),
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "concreteType": "JiraIssueSearchFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "RequiredField",
                                            "field": {
                                              "concreteType": "JiraIssueSearchFieldSet",
                                              "kind": "LinkedField",
                                              "name": "node",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "kind": "RequiredField",
                                                  "field": (v18/*: any*/),
                                                  "action": "THROW",
                                                  "path": "jira.issueSearchViewResult.fieldSets.edges.node.fieldSetId"
                                                },
                                                {
                                                  "kind": "RequiredField",
                                                  "field": (v19/*: any*/),
                                                  "action": "THROW",
                                                  "path": "jira.issueSearchViewResult.fieldSets.edges.node.displayName"
                                                },
                                                {
                                                  "kind": "RequiredField",
                                                  "field": (v20/*: any*/),
                                                  "action": "THROW",
                                                  "path": "jira.issueSearchViewResult.fieldSets.edges.node.type"
                                                },
                                                (v21/*: any*/),
                                                (v22/*: any*/)
                                              ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.issueSearchViewResult.fieldSets.edges.node"
                                          }
                                        ]
                                      },
                                      "action": "THROW",
                                      "path": "jira.issueSearchViewResult.fieldSets.edges"
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "jira.issueSearchViewResult.fieldSets"
                              }
                            ],
                            "type": "JiraIssueSearchView"
                          }
                        ]
                      },
                      "action": "THROW",
                      "path": "jira.issueSearchViewResult"
                    }
                  ]
                }
              ]
            },
            {
              "condition": "shouldUseNewQuery",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v23/*: any*/),
                    "kind": "LinkedField",
                    "name": "jiraIssueSearchView",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v14/*: any*/),
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v15/*: any*/),
                                "action": "THROW",
                                "path": "jira.jiraIssueSearchView.fieldSets.totalCount"
                              },
                              (v16/*: any*/),
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraIssueSearchFieldSetEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    (v17/*: any*/),
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "concreteType": "JiraIssueSearchFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "RequiredField",
                                            "field": (v18/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.fieldSetId"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v19/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.displayName"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v20/*: any*/),
                                            "action": "THROW",
                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.type"
                                          },
                                          (v21/*: any*/),
                                          (v22/*: any*/)
                                        ]
                                      },
                                      "action": "THROW",
                                      "path": "jira.jiraIssueSearchView.fieldSets.edges.node"
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraIssueSearchView.fieldSets.edges"
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jiraIssueSearchView"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "fetchColumnPickerOptionsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "shouldSkipOldQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v13/*: any*/),
                "concreteType": "JiraIssueSearchView",
                "kind": "LinkedField",
                "name": "issueSearchViewByNamespaceAndViewId",
                "plural": false,
                "selections": [
                  {
                    "args": (v14/*: any*/),
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v24/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldUseNewQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "shouldUseIFCOldQuery",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v13/*: any*/),
                    "kind": "LinkedField",
                    "name": "issueSearchViewResult",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v26/*: any*/),
                        "type": "JiraIssueSearchView"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldUseNewQuery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v23/*: any*/),
                "kind": "LinkedField",
                "name": "jiraIssueSearchView",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v26/*: any*/),
                    "type": "JiraSpreadsheetView",
                    "abstractKey": "__isJiraSpreadsheetView"
                  },
                  (v24/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "784261a4d425109d278a3a61a6672faf0cfea7f14a8a1d3b4fa6f4a70e01f76e",
    "metadata": {},
    "name": "fetchColumnPickerOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0fc6471b851cb363258490b714590f21";

export default node;
